import { render, staticRenderFns } from "./lineDoctor.vue?vue&type=template&id=65700668&scoped=true"
import script from "./lineDoctor.vue?vue&type=script&lang=js"
export * from "./lineDoctor.vue?vue&type=script&lang=js"
import style0 from "./lineDoctor.vue?vue&type=style&index=0&id=65700668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65700668",
  null
  
)

export default component.exports